module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 640 480\" version=\"1\"><g fill-rule=\"evenodd\" stroke-width=\"1pt\"><path fill=\"#fc0\" d=\"M0 320h640v160.002H0z\"/><path d=\"M0 0h640v160H0z\"/><path fill=\"red\" d=\"M0 160h640v160H0z\"/></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./icons/flag/de.svg
// module id = 48
// module chunks = 0